import React, { useState, useContext, useEffect } from 'react'
import ProductFieldsView from '@/product/components/organisms/Product/FieldsView'
import { dateTimeFormatFunction } from '@/product/common/components'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import * as Yup from 'yup'
import Layout from '@/product/components/templates/Layout'
import { useHistory } from 'react-router-dom'

const DynamicListing = (props) => {
    const dynamicContext = useContext(DynamicContext)

    const { project_dynamicfields } = dynamicContext
    const history = useHistory()

    const [updatedValues, setUpdatedValues] = useState({})
    const [asinMapData, setAsinMapData] = useState([])
    const [homeMapData, setHomeMapData] = useState([])
    const [data, setData] = useState({
        popup: false,
        status: 'newTemplate',
        id: 0,
        projectType: 0,
    })

    useEffect(() => {
        if (props?.match?.params?.id && props?.match?.params?.status) {
            setData({
                popup: true,
                status: props?.match?.params?.status,
                id: props?.match?.params?.id,
                projectType: 0,
            })
        }
    }, [props?.match?.params?.id, props?.match?.params?.status])

    const [fieldValue, setFieldValue] = useState([])

    useEffect(() => {
        if (project_dynamicfields && project_dynamicfields.length) {
            let projectDynamicArray = [...project_dynamicfields]
            let dynamicValueAssign = []
            let projectType = props?.data?.projectType
            console.log('something 1 ', projectType, projectDynamicArray)
            projectDynamicArray
                .filter((data) => data.active === 1)
                .map((item) => {
                    if (item.view_on && projectType) {
                        if (
                            item.view_on.includes(projectType) ||
                            item.view_on.includes('10')
                        ) {
                            if (item.name === 'qty') {
                                item.initialDefault = 1
                            } else if (item.name === 'sprice') {
                                item.initialDefault = 1
                            } else if (item.type == 'uploadDropZone') {
                                item.isCrop = true
                            }
                            dynamicValueAssign.push(item)
                        }
                    } else {
                        if (item.name === 'qty') {
                            item.initialDefault = 1
                        } else if (item.name === 'sprice') {
                            item.initialDefault = 1
                        } else if (item.type == 'uploadDropZone') {
                            item.isCrop = true
                        }
                        dynamicValueAssign.push(item)
                    }
                })
            dynamicValueAssign.push(
                {
                    name: 'market_status',
                    value: 'draft',
                    type: 'default',
                    active: 1,
                },
                {
                    name: 'auctiontype',
                    value: 'live',
                    type: 'default',
                    active: 1,
                }
            )
            console.log(
                'something 2 ',
                projectType,
                projectDynamicArray,
                dynamicValueAssign
            )
            setFieldValue(dynamicValueAssign)
        }
    }, [project_dynamicfields, props.data])

    const additionalFieldUpdate = (data) => {
        setUpdatedValues(data)
    }
    const closeFunction = () => {
        history.goBack()
    }
    return (
        <>
            <ProductFieldsView
                fieldValue={fieldValue}
                userId={props.userId}
                data={props.data}
                showasin={true}
                homeDepot={true}
                function={props.function}
                asinMapData={asinMapData}
                homeMapData={homeMapData}
                additionalFieldUpdate={additionalFieldUpdate}
                closeFunction={closeFunction}
                customFilter={props.customFilter}
                standalone={true}
            />
        </>
    )
}

export default DynamicListing
